// What happened when a document was made and saved to SharePoint: why it
// failed, or where it was saved with its "Open in SharePoint" link (the way in
// when the browser refused the new tab, lib/file-handoff.ts). Shared by the
// proposal, the Schedule of Work and the condition report.
import { OutboundLink } from '@higgins/ui';
import { ErrorMessage } from './message';

export interface SavedResult {
  ok: boolean;
  text: string;
  url?: string;
}

export function SavedDocumentResult({ result, className = 'mt-2' }: { result: SavedResult | null; className?: string }) {
  if (!result) return null;
  if (!result.ok) return <ErrorMessage className={className}>{result.text}</ErrorMessage>;
  return (
    <p className={`${className} text-sm text-green-800`}>
      {result.text}{' '}
      {result.url && (
        <OutboundLink openIn="edge" href={result.url} className="text-primary underline">
          Open in SharePoint
        </OutboundLink>
      )}
    </p>
  );
}
